import React from 'react';

function hasACL(acl) {
	var userACL = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).acls : [];
	return userACL.includes(acl);
}

export default hasACL;